/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Branding_TitleInputs */

const cs_templates_branding_title = /** @type {(inputs: Templates_Branding_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrola brandingu`)
};

const en_templates_branding_title = /** @type {(inputs: Templates_Branding_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branding checklist`)
};

/**
* | output |
* | --- |
* | "Branding checklist" |
*
* @param {Templates_Branding_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_branding_title = /** @type {((inputs?: Templates_Branding_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Branding_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_branding_title(inputs)
	return cs_templates_branding_title(inputs)
});